// import Autosuggest from 'react-autosuggest'
import React, { Component } from 'react'
// import { connect } from 'react-redux'
import CSSModules from 'react-css-modules'
import config from 'config'
// import {Row, Col} from 'react-flexbox-grid'
// import * as searchActions from 'redux/modules/search'
import {
  Works,
  Link,
  GetStartedInput,
  AboutBanner,
  FamilyGrid,
  BenchmarkGrid,
  TargetDateGrid,
  SrOnly,
  AutocompleteSearch,
  LinkIcon,
  AykCtaPanel,
} from '../../components'
// import format from '../../helpers/format'
// import Loader from 'react-loader'
import ReactPlayer from 'react-player'

const Styles = require('./Home.css')

// @connect(
//   state => ({
//     signupsubmit: state.signupsubmit.result
//   }),
//   searchActions)
@CSSModules(Styles, {allowMultiple:true})
export default class Home extends Component {
  static propTypes = {
    // signupsubmit: PropTypes.bool
  }

  constructor(props) {
    super(props)
    this.state = {
      // openModal: true,
    }
  }

  componentWillMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
  }

  componentDidMount() {
    // const signupsubmit = this.props.signupsubmit ?
    //   this.props.signupsubmit :
    //   false
    // this.props.signupsubmitChange(signupsubmit)
  }

  // clickCloseModal = () =>{
  //   this.props.signupsubmitChange(true)
  // }

  render() {
    // IMAGES
    const aysCircleLogo = require('../../../static/images/icn-ays.png')
    const aysLogo = require('../../../static/images/AsYouSow_Logo_color.svg')
    const equileapLogo = require('../../../static/images/equileap-logo.png')
    const subscoreAIcon = require(
      '../../../static/images/GEF-icons-gender-balance-peer-rank.svg'
    )
    const subscoreBIcon = require(
      '../../../static/images/GEF-icons-gender-equality-peer-rank.svg'
    )
    const subscoreCIcon = require(
      '../../../static/images/GEF-icons-gender-equality-policies-rank.svg'
    )
    const subscoreDIcon = require(
      '../../../static/images/GEF-icons-gender-equality-policies-score.svg'
    )
    //
    return (
      <div styleName="main">

        { /* SPLASH BANNER WITH AUTOCOMPLETE SEARCH */ }
        <div styleName='banner-wrapper-mobile'>
          <div styleName='banner-container'>
            <div styleName='banner-container-inner'>
              <div styleName='banner-wrapper'>
                <div styleName='banner-title'>
                  You have the power to invest in gender equality
                </div>
                <div styleName='banner-btn-wrap'>
                  <Link
                    to={config.routes.clean}
                    bigbutton
                    title='Top-scoring funds'
                  >
                    <div>
                      Top-scoring funds<LinkIcon />
                    </div>
                  </Link>
                </div>
                <div styleName='banner-tagline'>
                  Search for mutual funds or ETFs from your 401(k), retirement
                  plan, or personal portfolio
                </div>

                { /* AUTOCOMPLETE SEARCH INPUT */ }
                <AutocompleteSearch />
                <div styleName='banner-btn-wrap'>
                  <div styleName='logo-tagline'>
                    A project of
                  </div>
                  <Link to={config.links.ays} title='As You Sow'>
                    <img
                      styleName='logo-ays'
                      src={aysLogo}
                      alt='As You Sow'
                    />
                    <SrOnly>As You Sow</SrOnly>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        <AykCtaPanel />

        <br/>
        <br/>
        
        <div styleName='x-lede'>
          <div styleName='x-lede-inner'>

            { /* VIDEO */ }
            <div styleName='media-col'>
              <div styleName='media-icon-title-wrap'>
                <img
                  styleName='media-icon'
                  alt='From As You Sow'
                  src={aysCircleLogo}
                />
                <div styleName='media-title-wrap'>
                  <div styleName='media-title'>
                    Introducing: Gender Equality Funds
                  </div>
                  <div styleName='media-subtitle'>
                    From As You Sow
                  </div>
                </div>
              </div>
              <div styleName='media-react-player-wrap'>
                <ReactPlayer
                  url='https://vimeo.com/367115693'
                  volume={0.5}
                />
              </div>
            </div>

            { /* LEDE PARAGRAPH */ }
            <div styleName='x-lede-title'>
              Invest your values
            </div>
            <div styleName='x-lede-subtitle-2'>
              <strong>Individual and institutional investors can align their
              actions with their values, and take responsibility for the
              investments they own.</strong> Aligning investments with values
              requires that you know what you own — but if you’re invested through
              mutual funds, it has been nearly impossible to know what
              individual companies you own. That’s changed with As You
              Sow’s <strong>Gender Equality Funds</strong>.  Now, you can
              harness your personal economic power to confront big business.
            </div>
          </div>
        </div>

        <br/>
        <br/>
        <br/>

        { /* HOW IT WORKS BANNER */ }
        <Works/>

        { /* MORE INFO PARAGRAPHS */ }
        <div styleName='x-lede'>
          <div styleName='x-lede-inner'>
            <div styleName='lower-lede-cols'>
              <div styleName='lower-lede-col'>
                <p>
                  <strong>Gender Equality Funds</strong> is powered by
                  the <Link
                    to={config.links.equileapResearch}
                    title='Equileap reports - Equileap'
                    xstrong
                  >Equileap Gender Equality Scorecard</Link>, inspired by the
                  UN’s Women Empowerment Principles. The Equileap Gender
                  Equality Scorecard scores companies based on 19 criteria,
                  including gender balance across the workforce, the gender
                  pay gap, paid parental leave, and anti-sexual harassment
                  policies.
                </p>
                <img
                  styleName='logo-equileap'
                  src={equileapLogo}
                  alt='As You Sow'
                />
              </div>
              <div styleName='lower-lede-col-2'>
                <div styleName='small-title'>
                  <div styleName='icon-label-wrap'>
                    <img
                      src={subscoreAIcon}
                      alt='Gender balance in leadership and workforce'
                      styleName='inline-icon-sm'
                    />
                    <div styleName='icon-label'>
                      Gender balance in leadership and workforce
                    </div>
                  </div>
                </div>
                <ul>
                  <li>
                    <strong>1 - Board of Directors</strong> - Percentage of
                    male and female Board of Directors as a proportion of the
                    total number.
                  </li>
                  <li>
                    <strong>2 - Executives</strong> - Percentage of male and
                    female Executives as a percentage of the total number.
                  </li>
                  <li>
                    <strong>3 - Senior Management</strong> - Percentage of
                    male and female senior managers as a percentage of total.
                  </li>
                  <li>
                    <strong>4 - Workforce</strong> - Percentage of male and
                    female employees as a percentage of total.
                  </li>
                  <li>
                    <strong>5 - Promotion and Career Development
                    Opportunities</strong> - Ratio of each gender in Senior
                    Management compared to ratio of each gender in the
                    Workforce.
                  </li>
                </ul>
              </div>
              <div styleName='lower-lede-col-2'>
                <div styleName='small-title'>
                  <div styleName='icon-label-wrap'>
                    <img
                      src={subscoreBIcon}
                      alt='Equal compensation and work life balance'
                      styleName='inline-icon-sm'
                    />
                    <div styleName='icon-label'>
                      Equal compensation and work life balance
                    </div>
                  </div>
                </div>
                <ul>
                  <li>
                    <strong>6 - Living Wage</strong> - Commitment to ensure
                    payment of a living wage to all employees, even in those
                    countries that do not legally require a minimum wage or
                    where minimum wage is not a living wage.
                  </li>
                  <li>
                    <strong>7 - Gender Pay Gap</strong> - Commitment to
                    provide comparable wages for comparable work and to close
                    the gender pay gap.
                  </li>
                  <li>
                    <strong>8 - Parental Leave</strong> - Paid leave programs
                    (at least 2/3 paid) for child care to both primary or
                    secondary carers globally or at least in the country of
                    incorporation.
                  </li>
                  <li>
                    <strong>9 - Flexible Work Options</strong> - Option for
                    employees to control and/or vary the start and end times
                    of the work day and/or vary the location from which
                    employees work.
                  </li>
                </ul>
              </div>
              <div styleName='lower-lede-col-2'>
                <div styleName='small-title'>
                  <div styleName='icon-label-wrap'>
                    <img
                      src={subscoreCIcon}
                      alt='Policies promoting gender equality'
                      styleName='inline-icon-sm'
                    />
                    <div styleName='icon-label'>
                      Policies promoting gender equality
                    </div>
                  </div>
                </div>
                <ul>
                  <li>
                    <strong>10 - Training and Career Development</strong> -
                    Commitment to ensure equal access to training and career
                    development to both men and women.
                  </li>
                  <li>
                    <strong>11 - Recruitment Strategy</strong> - Commitment to
                    ensure non-discrimination against any type of demographic
                    group and equal opportunities to ensure gender parity.
                  </li>
                  <li>
                    <strong>12 - Freedom from Violence, Abuse and Sexual
                    Harassment</strong> - Prohibits all forms of violence in
                    the work place, including verbal, physical and sexual
                    harassment.
                  </li>
                  <li>
                    <strong>13 - Safety at Work</strong> - Commitment to the
                    safety of employees in the workplace, in travel to and
                    from the workplace, and on company related business, and
                    ensure the safety of vendors in the workplace.
                  </li>
                  <li>
                    <strong>14 - Human Rights</strong> - Commitment to ensure
                    the protection of the rights of all people it works with
                    including employees’ rights to participate in legal, civic
                    and political affairs.
                  </li>
                  <li>
                    <strong>15 - Social Supply Chain</strong> - Commitment to
                    reduce social risks in its supply chain such as forbid
                    business related activities that condone, support, or
                    otherwise participate in trafficking, including for labor
                    or sexual exploitation.
                  </li>
                  <li>
                    <strong>16 - Supplier Diversity</strong> - Commitment to
                    ensure diversity in the supply chain, including support
                    for women owned businesses in the supply chain.
                  </li>
                  <li>
                    <strong>17 - Employee Protection</strong> - Systems and
                    policies for the reporting of internal ethical compliance
                    complaints without retaliation or retribution, including
                    but not limited to access to confidential third-party
                    ethics hotlines or systems for confidential written
                    complaints.
                  </li>
                </ul>
              </div>
              <div styleName='lower-lede-col-2'>
                <div styleName='small-title'>
                  <div styleName='icon-label-wrap'>
                    <img
                      src={subscoreDIcon}
                      alt='Commitment, transparency, and accountability'
                      styleName='inline-icon-sm'
                    />
                    <div styleName='icon-label'>
                      Commitment, transparency, and accountability
                    </div>
                  </div>
                </div>
                <ul>
                  <li>
                    <strong>18 - Commitment to Women’s Empowerment</strong> -
                    Recognition and commitment to ensuring women’s empowerment
                    in the workplace.
                  </li>
                  <li>
                    <strong>19 - Audit</strong> - Undertaken and awarded an
                    independent gender audit certificate by an Equileap
                    recognized body.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        { /* GET STARTED BANNER */ }
        { /* <GetStartedInput/> */ }

        { /* INDEX FUNDS BANNER */ }
        { /* <BenchmarkGrid /> */ }

        { /* TARGET DATE FUNDS BANNER */ }
        { /* <TargetDateGrid /> */ }

        { /* ASSET MANAGERS BANNER */ }
        { /* <FamilyGrid /> */ }

        { /* TRAILING PARAGRAPHS */ }
        <div styleName='x-401k'>
          <div styleName='x-401k-inner'>
            <div styleName='x-401k-title'>
              Tracking trillions in investments
            </div>
            <div styleName='x-401k-info-photo'>
              <div styleName='x-401k-info'>
                <p styleName='x-401k-top'>
                  Gender lens investing isn't just a moral question. Research
                  shows gender diverse companies tend to have better returns
                  and lower risk.
                </p>
                <blockquote>
                  Equal pay and, more broadly, equal opportunities at work are
                  powerful levers to grow global prosperity: they have the
                  potential to take millions of women and their families out
                  of poverty and move us closer to achieving the Sustainable
                  Development Goals by 2030, as defined by the United Nations.
                  <br/>
                  – Equileap, Gender Equality Global Report and Ranking (2017)
                </blockquote>
                <p>
                  Discover which funds are investing in the companies that
                  lead the field in terms of gender equality. A growing body
                  of evidence correlates various gender-lens investing
                  criteria with higher financial performance and lower
                  investment risk.
                </p>
                <p>
                  Use <strong>Gender Equality Funds</strong> to search and
                  compare mutual funds based on their gender-lens score and
                  financial performance. You can use our database to find
                  sustainable investment options that meet your specific
                  needs.
                </p>
              </div>
            </div>

            { /* ABOUT BANNER */ }
            <AboutBanner />
          </div>
        </div>

        { /* GET STARTED BANNER */ }
        <GetStartedInput/>
      </div>
    )
  }
}

